module.exports = __webpack_public_path__ + "static/media/recordista_d.5c26f86a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/recordista_d.png
// module id = 1174
// module chunks = 0